import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

/**
 * Estado inicial da tabela — exibido antes da primeira pesquisa, no lugar de uma
 * lista vazia que sugeriria "nenhum resultado".
 */
export function IndividualPaymentSearchPrompt() {
  const { t } = useTranslation('individualPayment');

  return (
    <div className="flex flex-col items-center justify-center gap-mini px-xs py-xl">
      <div className="flex h-xl w-xl items-center justify-center rounded-pill bg-ctx-layout-body">
        <MagnifyingGlassIcon className="h-xxs w-xxs text-ctx-content-placeholder" />
      </div>
      <span className="ts-heading-xs text-ctx-content-title">{t('searchPrompt.title')}</span>
      <p className="max-w-[35rem] text-center ts-paragraph-xs text-ctx-content-base">
        {t('searchPrompt.description')}
      </p>
    </div>
  );
}
